module.exports = __webpack_public_path__ + "img/45.a3a53b58.jpg";